export default function LoadError({ message, onRetry, testId = "load-error" }) {
  return (
    <div className="py-10 text-center" role="alert" data-testid={testId}>
      <p className="text-slate-500">{message}</p>
      <button
        type="button"
        data-testid={`${testId}-retry`}
        onClick={onRetry}
        className="mt-3 rounded-xl bg-[#2F6BFF] px-4 py-2 text-sm font-semibold text-white active:scale-95"
      >
        Повторить
      </button>
    </div>
  );
}
